import React from 'react';
import { StarIcon } from 'lucide-react';
import { Tag } from './ui/Tag';
import { resultStats, testimonials } from '../data/landing';
function Stars() {
  return <div className="flex gap-1" role="img" aria-label="5 de 5 estrellas" data-id="element-143" data-mp="20tjobllezkgq">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-[#fbbf24] text-[#fbbf24]" aria-hidden="true" data-id="element-144" data-mp="1r143mgiqghs5" data-mpi={index} />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-[#f8fafc] py-20 sm:py-28" aria-labelledby="testimonios-title" data-id="element-145" data-mp="1d0jmrpwdow1a">
      <div className="mx-auto w-full max-w-6xl px-6" data-id="element-146" data-mp="1i28uavke6rkm">
        <div className="mx-auto max-w-2xl text-center" data-id="element-147" data-mp="141y6y2iajv47">
          <Tag data-id="element-148" data-mp="143izjml1p3zf">Resultados Reales</Tag>
          <h2 id="testimonios-title" className="mt-6 font-serif text-3xl font-bold leading-tight text-[#0f172a] sm:text-4xl lg:text-5xl" data-id="element-149" data-mp="181zwxeenz03n">
            Lo que dicen los que ya tienen el Sistema
          </h2>
        </div>

        <ul className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-150" data-mp="32fhordm3qj4h">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex flex-col rounded border border-slate-200 bg-white p-7" data-id="element-151" data-mp="2v0j4nld2nwxo">
              <Stars data-id="element-152" data-mp="2q1pxsbsaj46h" />
              <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-slate-700" data-id="element-153" data-mp="2q0eyao5voil6">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-6 border-t border-slate-100 pt-4" data-id="element-154" data-mp="2zs17yg2ki9lt">
                <p className="font-serif text-base font-bold text-[#0f172a]" data-id="element-155" data-mp="2c2q9544s2pab">
                  {testimonial.name}
                </p>
                <p className="mt-0.5 text-xs text-slate-500" data-id="element-156" data-mp="274oseputr220">{testimonial.role}</p>
              </div>
            </li>)}
        </ul>

        <dl className="mt-14 grid grid-cols-2 gap-y-10 rounded bg-[#0f172a] px-6 py-12 sm:grid-cols-4" data-id="element-157" data-mp="2m27h5s7i5f9g">
          {resultStats.map(stat => <div key={stat.label} className="text-center" data-id="element-158" data-mp="1anf1u821p9i">
              <dt className="sr-only" data-id="element-159" data-mp="1942adllxwch">{stat.label}</dt>
              <dd data-id="element-160" data-mp="3shhvazbbz0b6">
                <span className="block font-serif text-3xl font-bold text-[#22c55e] sm:text-4xl" data-id="element-161" data-mp="3sfx0r9p0nhdb">
                  {stat.value}
                </span>
                <span className="mt-2 block px-2 text-[11px] uppercase tracking-[0.14em] text-slate-400" data-id="element-162" data-mp="3h514a6u79zx">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}